var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "table-row body-row",
      class: { "is-selected": _vm.isSelected },
    },
    [
      _vm.selectionEnabled
        ? _c("div", { staticClass: "selection-cell table-cell body-cell" }, [
            _c("input", {
              attrs: { type: "checkbox" },
              domProps: { checked: _vm.isSelected },
              on: { change: _vm.handleChange },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.fields, function (field) {
        return _c(
          "div",
          { key: field.name, staticClass: "table-cell body-cell" },
          [
            _c("div", { staticClass: "inline-label" }, [
              _vm._v(_vm._s(field.label)),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "cell-content",
              domProps: { innerHTML: _vm._s(_vm.object[field.name]) },
            }),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }